import { FunctionComponent } from "react";

import { Button, Flex, Grid, GridItem, HStack, Text } from "@chakra-ui/react";

export interface GlobalEngageTopBannerProps {
    description: string;
    engageLink: string;
    infoLink: string;
    infoLinkText: string;
    note?: string;
    title?: string;
    engageLinkText?: string;
    supportingButtonText?: string;
    supportingButtonLink?: string;
}
export const GlobalEngageTopBanner: FunctionComponent<GlobalEngageTopBannerProps> = ({
    description,
    engageLink,
    infoLink,
    infoLinkText,
    note,
    title,
    engageLinkText,
    supportingButtonText,
    supportingButtonLink,
}) => {
    return (
        <Flex
            width="100%"
            color="blackAlpha.900"
            justifyContent="flex-start"
            alignItems="center"
            minHeight="42px"
            px={4}
            backgroundImage="linear-gradient(90deg, #d18a00 0%, #d18a00 45%, rgba(209, 139, 0, 0.57) 55%), repeating-linear-gradient(110deg, rgba(181, 106, 0, 0.6) 0px, rgba(181, 106, 0, 0.6) 15px, rgba(181, 106, 0, 0.30) 15px, rgba(181, 106, 0, 0.30) 25px)"
            backgroundSize="100% 100%, 45% 100%"
            backgroundPosition="left top, right top"
            backgroundRepeat="no-repeat, repeat"
        >
            <Grid mb={2} pr={2} width="100%" templateColumns={{ base: "1fr", lg: "1fr auto" }} columnGap={4} rowGap={2} alignItems="center">
                <GridItem justifySelf="start">
                    {title && <Text color="black" fontSize={{ base: "sm", lg: "md" }} dangerouslySetInnerHTML={{ __html: title }} />}
                    {description && <Text color="black" fontSize={{ base: "sm", lg: "md" }} dangerouslySetInnerHTML={{ __html: description }} />}
                    {note && <Text color="black" fontSize={{ base: "sm", lg: "md" }} dangerouslySetInnerHTML={{ __html: note }} />}
                </GridItem>

                <GridItem justifySelf={{ base: "start", lg: "end" }}>
                    <HStack spacing={2}>
                        <Button
                            as="a"
                            href={infoLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="sm"
                            variant="outline"
                            borderColor="blackAlpha.900"
                            color="blackAlpha.900"
                            _hover={{ bg: "blackAlpha.200", textDecoration: "none" }}
                        >
                            {infoLinkText}
                        </Button>
                        <Button
                            as="a"
                            href={engageLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="sm"
                            variant="solid"
                            bg="white"
                            color="blackAlpha.700"
                            _hover={{ bg: "gray.100", textDecoration: "none" }}
                        >
                            {engageLinkText}
                        </Button>
                        {supportingButtonText && supportingButtonLink && (
                            <Button
                                as="a"
                                href={supportingButtonLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                size="sm"
                                variant="solid"
                                bg="white"
                                color="blackAlpha.700"
                                _hover={{ bg: "gray.100", textDecoration: "none" }}
                            >
                                {supportingButtonText}
                            </Button>
                        )}
                    </HStack>
                </GridItem>
            </Grid>
        </Flex>
    );
};
